import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LanguageRepository } from '@app-core/state/language.repository';
import { SessionRepository } from '@app-core/state/session.repository';
import { map } from 'rxjs';
import { CountryRepository } from 'src/app/entities/countries/state/country.repository';
import { RoutePaths } from 'src/app/routes/route-paths.enum';

export const appLanguageGuard: CanActivateFn = (_route, state) => {
  const languageRepo = inject(LanguageRepository);
  const router = inject(Router);
  const countryRepo = inject(CountryRepository);

  const sessionRepo = inject(SessionRepository);

  return languageRepo.hasUserChosenLanguage$.pipe(
    map(hasChosen => {
      if (hasChosen) return true;

      sessionRepo.setStoreProp('savedRoute', state.url);
      router.navigate([
        countryRepo.getStoreProp('countryParam'),
        RoutePaths.LanguageSelection,
      ]);

      return false;
    }),
  );
};
